import { JsonObject, JsonProperty } from '../convert/convert-core';

@JsonObject('ErrorInfoVO')
export class ErrorInfoVO {

  @JsonProperty('error', 'String')
  public error: string;
  public title: string;
  @JsonProperty('message', 'String')
  public message: string;


  public constructor(error: string, title: string, message: string) {
    this.error = error;
    this.title = title;
    this.message = message;
  }
}
